import React from "react";
import { motion } from "framer-motion";

// Scroll fade-up reveal wrapper used across sections/cards.
const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
